// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectColumns_container__3bRqz","column":"ProjectColumns_column__1izHf","fullBleed":"ProjectColumns_fullBleed__3uaDf","bounce":"ProjectColumns_bounce__1yPgr"};